import classNames from 'classnames';

export type ToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
};

export const Toggle = ({
  checked,
  onChange,
  disabled = false,
  className,
  'aria-label': ariaLabel,
}: ToggleProps) => {
  const handleClick = () => {
    if (disabled) return;
    onChange(!checked);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={handleClick}
      className={classNames(
        'relative inline-flex h-[2.4rem] w-[4.2rem] items-center rounded-[3.2rem] border border-brightGray transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-dodgerBlue focus:ring-offset-2',
        {
          'bg-dodgerBlue cursor-pointer': checked && !disabled,
          'bg-ghostWhite cursor-pointer': !checked && !disabled,
          'opacity-50 cursor-not-allowed': disabled,
        },
        className
      )}
    >
      <span
        aria-hidden="true"
        className={classNames(
          'h-[2rem] w-[2rem] rounded-full bg-white shadow-sm transition-transform duration-200',
          {
            'translate-x-[2rem]': checked,
            'translate-x-[0.2rem]': !checked,
          }
        )}
      />
    </button>
  );
};